/* eslint-disable no-param-reassign */
import {
  fibreOfferField,
  fieldAddProductVulcan,
  fieldNumberOfAccessPoints,
  fieldProvinceVUL,
  quebecProvince,
  ontarioProvince
} from '../../utils/constant';
import { getFieldValue } from '../utils';
import {
  fibreSpeed,
  fieldInstallation
} from '../vulcanPricing/fibeInternet/fibreInternetFieldNames';
import EN from '../../../EN.json';
import FR from '../../../FR.json';
import { useLocaleContext } from '../../context/LocaleContext';

const disableOptions = (options, targets, value) => {
  const updatedOptions = [...options];
  targets.forEach(target => {
    updatedOptions.forEach(option => {
      if (option.fields.value === target) {
        // eslint-disable-next-line no-param-reassign
        option.fields.disabledOption = value;
      }
    });
  });
  return updatedOptions;
};

const FibreBusinessWifiHelpers = ({ formFields, fieldName, fields }) => {
  const locale = useLocaleContext();

  const {
    vulcanWebform: {
      vulBusinessWifi,
      vulOnePointFiveG,
      vulThreeG,
      vulHundredDollarInstallationFee,
      vulTenDollarInternetBundleDiscount,
      vulHundredBillCreditHSIA,
      vulFifteenDollarInternetBundleDiscountATL,
      vulBTLOption,
      vulATLOption,
      vulFortyDollarInternetDiscountATL,
      vulTwentyDollarInternetDiscountBTL,
      vulSixtyDollarInternetDiscountATL,
      vulSixtyDollarInternetDiscountBTL,
      vulFifteenDollarInternetBundleDiscount,
      vulSeventyDollarInternetDiscount,
      vulFortyFiveDollarInternetDiscountATL,
      vulTwentyFiveInternetBundleDiscount,
      vulEightyDollarInternetDiscount,
      vulThirtyInternetBundleDiscount
    }
  } = locale === 'en-US' ? EN : FR;

  const threeGOffers = [
    vulFifteenDollarInternetBundleDiscount,
    vulHundredBillCreditHSIA,
    vulSeventyDollarInternetDiscount
  ];

  const onePointFiveGOffers = [
    vulTenDollarInternetBundleDiscount,
    vulFortyFiveDollarInternetDiscountATL,
    vulSeventyDollarInternetDiscount,
    vulHundredBillCreditHSIA,
    vulFifteenDollarInternetBundleDiscount
  ];

  const threeGOffersForQuebec = [
    vulFifteenDollarInternetBundleDiscountATL,
    vulTwentyDollarInternetDiscountBTL,
    vulFortyDollarInternetDiscountATL,
    vulSeventyDollarInternetDiscount,
    vulHundredBillCreditHSIA
  ];

  const onePointFiveGOffersForQuebec = [
    vulTenDollarInternetBundleDiscount,
    vulThirtyInternetBundleDiscount,
    vulSixtyDollarInternetDiscountATL,
    vulSeventyDollarInternetDiscount,
    vulHundredBillCreditHSIA
  ];

  const onePointFiveGOffersForOntario = [
    // vulFifteenDollarInternetBundleDiscount,
    vulTenDollarInternetBundleDiscount,
    vulThirtyInternetBundleDiscount,
    vulFortyFiveDollarInternetDiscountATL,
    vulSeventyDollarInternetDiscount,
    vulHundredBillCreditHSIA
  ];

  const threeGOffersForOntario = [
    // vulFifteenDollarInternetBundleDiscountATL,
    // vulFortyDollarInternetDiscountATL,
    vulFifteenDollarInternetBundleDiscount,
    vulSeventyDollarInternetDiscount,
    vulHundredBillCreditHSIA
  ];

  const getValidOffersForSpeed = (
    formFields,
    fieldName
  ) => {
    if (fieldName === fibreOfferField) {
      const fibreSpeedFieldValue = getFieldValue(fibreSpeed, formFields);
      const serviceAddress = getFieldValue(fieldProvinceVUL, formFields);
  
      if (fibreSpeedFieldValue === vulThreeG) {
        if (quebecProvince.includes(serviceAddress)) {
          return formFields[fibreOfferField].options.filter(value =>
            threeGOffersForQuebec.includes(value.fields.value)
          );
        } else if (ontarioProvince.includes(serviceAddress)) {
          return formFields[fibreOfferField].options.filter(value =>
            threeGOffersForOntario.includes(value.fields.value)
          );
        } else {
          return formFields[fibreOfferField].options.filter(value =>
            threeGOffers.includes(value.fields.value)
          );
        }
      }
  
      if (fibreSpeedFieldValue === vulOnePointFiveG) {
        if (quebecProvince.includes(serviceAddress)) {
          return formFields[fibreOfferField].options.filter(value =>
            onePointFiveGOffersForQuebec.includes(value.fields.value)
          );
        } else if (ontarioProvince.includes(serviceAddress)) {
          return formFields[fibreOfferField].options.filter(value =>
            onePointFiveGOffersForOntario.includes(value.fields.value)
          );
        } else {
          return formFields[fibreOfferField].options.filter(value =>
            onePointFiveGOffers.includes(value.fields.value)
          );
        }
      }
  
      return formFields[fibreOfferField].options;
    }
    return [];
  };

  const addProductVulcanValue = getFieldValue(
    fieldAddProductVulcan,
    formFields
  );
  const fibreOfferFieldValue = getFieldValue(fibreOfferField, formFields);
  // Handle fibre offers visibility conditions
  if (fieldName === fibreOfferField) {
    const validOfferOptions = getValidOffersForSpeed(
      formFields,
      fieldName,
      fields
    );
    if (fibreOfferFieldValue) {
      const selectedOption = validOfferOptions.find(
        option => option.fields.value === fibreOfferFieldValue[0]
      );
      if (selectedOption) {
        const normalizedLabel = selectedOption.fields.label
          .toLowerCase()
          .trim();
        const normalizedATL = vulATLOption.toLowerCase().trim();
        const normalizedBTL = vulBTLOption.toLowerCase().trim();

        const isSelectedOptionBTL = normalizedLabel.includes(normalizedBTL);
        const isSelectedOptionATL =
          !isSelectedOptionBTL && normalizedLabel.includes(normalizedATL);

        if (isSelectedOptionATL) {
          const optionsToDisable = validOfferOptions
            .filter(
              option =>
                option.fields.label
                  .toLowerCase()
                  .trim()
                  .includes(normalizedATL) &&
                !option.fields.label
                  .toLowerCase()
                  .trim()
                  .includes(normalizedBTL)
            )
            .map(option => option.fields.value);
          fields.options = validOfferOptions.filter(value =>
            optionsToDisable.includes(value.fields.value)
          );
        } else if (isSelectedOptionBTL) {
          const optionsToDisable = validOfferOptions
            .filter(option =>
              option.fields.label
                .toLowerCase()
                .trim()
                .includes(normalizedBTL)
            )
            .map(option => option.fields.value);
          fields.options = validOfferOptions.filter(value =>
            optionsToDisable.includes(value.fields.value)
          );
        } else {
          fields.options = validOfferOptions;
        }
      } else {
        fields.options = validOfferOptions;
      }
    } else {
      fields.options = validOfferOptions;
    }
  }

  if (fieldName === fibreSpeed) {
    const serviceAddress = getFieldValue(fieldProvinceVUL, formFields);
    if (quebecProvince.includes(serviceAddress) || ontarioProvince.includes(serviceAddress)) {
      fields.options = formFields[fibreSpeed].options.filter(
        option => option.fields.label !== vulThreeG
      );
    } else {
      fields.options = formFields[fibreSpeed].options;
    }
  }

  if (fieldName === fieldInstallation) {
    formFields[fieldInstallation].value = [vulHundredDollarInstallationFee];
    disableOptions(fields.options, [vulHundredDollarInstallationFee], true);
  }

  if (fieldName === fieldAddProductVulcan) {
    if (!addProductVulcanValue.includes(vulBusinessWifi)) {
      formFields[fieldNumberOfAccessPoints].value = undefined;
      formFields['selectTheDevice'].value = '';
    } else if (
      addProductVulcanValue.includes(vulBusinessWifi) &&
      !formFields[fieldNumberOfAccessPoints].value
    ) {
      formFields[fieldNumberOfAccessPoints].value = 1;
    }
  }
};

export default FibreBusinessWifiHelpers;
